import { IPOOL, S3Asset } from '../../_utils/types';
import { actionTypes } from '../_actions/amm.action';

export interface AMM {
  usdValues: { [key: number]: number };
  pools: IPOOL[];
  selectedPoolId: number;
  assetsCache: S3Asset;
  topAssets: S3Asset;
}

const initialState: AMM = {
  usdValues: {},
  pools: [],
  selectedPoolId: null,
  assetsCache: {},
  topAssets: {},
};

const amm = (state = initialState, action): AMM => {
  switch (action.type) {
    case actionTypes.SAVE_ASSETS_USD_VALUES: {
      const newUsdValues = { ...state.usdValues };
      Object.keys(action.data).forEach((key) => {
        newUsdValues[key] = action.data[key];
      });
      return {
        ...state,
        usdValues: newUsdValues,
      };
    }
    case actionTypes.SAVE_POOLS: {
      return {
        ...state,
        pools: action.data,
      };
    }
    case actionTypes.SAVE_ACTIVE_POOL: {
      return {
        ...state,
        selectedPoolId: action.data,
      };
    }
    case actionTypes.CACHE_ASSET: {
      return {
        ...state,
        assetsCache: action.data,
      };
    }
    case actionTypes.SET_TOP_ASSETS: {
      return {
        ...state,
        topAssets: action.data,
      };
    }
    default:
      return state;
  }
};

export default amm;
